import React, { Component } from 'react';
import FaqButtonServiceDesign from '../faq-button-service/faq-button-service-redesign';


export default class LookingForMoreLinks extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {

        }
    }
    render() {
        const { getStoreAttValue } = this.props;

        return (
        <>
            {getStoreAttValue("HLP")!==''&& getStoreAttValue("HLP")!==null &&
                <div id="cssSummaryFaqContainer" className="wth3-moreLinksContainer__faq">
                    <h2 id="cssSummaryFaqTitle" className="wth3-moreLinksContainer__faq-title">Looking for more answers?</h2>
                    <p id='cssSummaryHelpCenterText' className="wth3-moreLinksContainer__faq-subTitle">Visit our <a href={getStoreAttValue("HLP")} id="cssSummaryHelpCenterButton" className="wth3-moreLinksContainer__faq-subTitle-helpLink" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker('BCSS Login', 'Help Center Home', '')}}>help center</a> or explore the categories below</p>
                    <div id="cssSummaryFaqButtonCont" class='wth3-moreLinksContainer__faq-faqContainer'>
                        <FaqButtonServiceDesign siteConfigData={this.props.siteConfigData} CallTracker={this.props.CallTracker} />
                    </div>
                </div>
            }
        </>
        )
    }
}